module.exports = __webpack_public_path__ + "img/price.9cdd07a3.svg";